export default [
  {
    path: 'M117.149737 906.850263V117.160081h789.690182v789.690182z m148.521374-641.706667v492.533657h248.873374V367.843556h145.025293v389.906101h98.735321V265.143596z',
    fill: '#CB3837',
  },
]
